import ApiBase from '../ApiBase';

class Stats extends ApiBase {
    route = 'admin/stats';
}

export default new Stats();
